import React from "react";
import { Editor as TinyMCEEditor } from "@tinymce/tinymce-react";

/**
 * TinyMCE wired to the self-hosted copy in public/tinymce.
 *
 * Without `tinymceScriptSrc` the component pulls TinyMCE from Tiny Cloud, which
 * shows "A valid API key is required to continue using TinyMCE" whenever the
 * key is missing, expired, or the current domain is not registered for it.
 * Serving our own TinyMCE 6 build removes the cloud call and the notification.
 *
 * Import this instead of `@tinymce/tinymce-react` and do not pass `apiKey`.
 */
export default function Editor(props) {
  return (
    <TinyMCEEditor
      {...props}
      tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
    />
  );
}

export { Editor };
